import React, { useState, useCallback, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

function FormHotelToAirport() {
 const navigate =useNavigate()
  const [formData, setFormData] = useState({
    currency: "USD",
    isReturn: false,
    vehicles: "Suburban",
    passengers: "1",
    departureDate: "2024-10-04",
    departureTime: "01:01",
    returnDate: "2024-10-04",
    returnTime: "00:00",
    from: "--- San Jose del Cabo ---",
    to: "(SJD) Los Cabos international Airpot",
    price: 0, // Inicializamos el precio como 0
  });

  const convertToCurrency = (amount, currency) => {
    const exchangeRate = 20.14; // Ejemplo: 1 USD = 18.5 MXN
    if (currency === "MXN") {
      return (amount * exchangeRate).toFixed(2);
    }
    return amount.toFixed(2); // Si es USD, se deja igual
  };

  // Calcular y actualizar el precio basado en el vehículo y si es retorno
  const calculatePrice = useCallback(() => {
    let basePrice = 0;
    const { vehicles, isReturn, currency } = formData;
    // San Jose del Cabo


    if (
      formData.from === "--- San Jose del Cabo ---" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 115 : 65;
    } else if (
      formData.from === "--- San Jose del Cabo ---" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 130 : 80;
    } else if (
      formData.from === "--- San Jose del Cabo ---" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 125 : 75;
    } else if (
      formData.from === "--- San Jose del Cabo ---" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 175 : 125;
    } else if (
      formData.from === "--- San Jose del Cabo ---" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (
      formData.from === "Cabo Azul, a Hilton Vacation Club" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 115 : 65;
    } else if (
      formData.from === "Cabo Azul, a Hilton Vacation Club" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 130 : 80;
    } else if (
      formData.from === "Cabo Azul, a Hilfromn Vacation Club" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 125 : 75;
    } else if (
      formData.from === "Cabo Azul, a Hilton Vacation Club" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 175 : 125;
    } else if (
      formData.from === "Cabo Azul, a Hilton Vacation Club" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (formData.from === "Cabo Surf" && vehicles === "Suburban") {
      basePrice = isReturn ? 115 : 65;
    } else if (formData.from === "Cabo Surf" && vehicles === "Escalade") {
      basePrice = isReturn ? 130 : 80;
    } else if (formData.from === "Cabo Surf" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 125 : 75;
    } else if (
      formData.from === "Cabo Surf" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 175 : 125;
    } else if (formData.from === "Cabo Surf" && vehicles === "Sprinter large") {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (formData.from === "Casa Natalia" && vehicles === "Suburban") {
      basePrice = isReturn ? 115 : 65;
    } else if (formData.from === "Casa Natalia" && vehicles === "Escalade") {
      basePrice = isReturn ? 130 : 80;
    } else if (formData.from === "Casa Natalia" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 125 : 75;
    } else if (
      formData.from === "Casa Natalia" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 175 : 125;
    } else if (
      formData.from === "Casa Natalia" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (formData.from === "Club La Costa" && vehicles === "Suburban") {
      basePrice = isReturn ? 115 : 65;
    } else if (formData.from === "Club La Costa" && vehicles === "Escalade") {
      basePrice = isReturn ? 130 : 80;
    } else if (formData.from === "Club La Costa" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 125 : 75;
    } else if (
      formData.from === "Club La Costa" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 175 : 125;
    } else if (
      formData.from === "Club La Costa" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (formData.from === "Drift Hotel" && vehicles === "Suburban") {
      basePrice = isReturn ? 115 : 65;
    } else if (formData.from === "Drift Hotel" && vehicles === "Escalade") {
      basePrice = isReturn ? 130 : 80;
    } else if (formData.from === "Drift Hotel" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 125 : 75;
    } else if (
      formData.from === "Drift Hotel" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 175 : 125;
    } else if (formData.from === "Drift Hotel" && vehicles === "Sprinter large") {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (formData.from === "El Encanto Inn" && vehicles === "Suburban") {
      basePrice = isReturn ? 115 : 65;
    } else if (formData.to === "El Encanto Inn" && vehicles === "Escalade") {
      basePrice = isReturn ? 130 : 80;
    } else if (
      formData.from === "El Encanto Inn" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 125 : 75;
    } else if (
      formData.from === "El Encanto Inn" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 175 : 125;
    } else if (
      formData.from === "El Encanto Inn" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (formData.from === "El Zalate Condos" && vehicles === "Suburban") {
      basePrice = isReturn ? 115 : 65;
    } else if (formData.from === "El Zalate Condos" && vehicles === "Escalade") {
      basePrice = isReturn ? 130 : 80;
    } else if (
      formData.from === "El Zalate Condos" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 125 : 75;
    } else if (
      formData.from === "El Zalate Condos" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 175 : 125;
    } else if (
      formData.from === "El Zalate Condos" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (
      formData.from === "Flamboyan Hotel and Residences" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 115 : 65;
    } else if (
      formData.from === "Flamboyan Hotel and Residences" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 130 : 80;
    } else if (
      formData.from === "Flamboyan Hotel and Residences" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 125 : 75;
    } else if (
      formData.from === "Flamboyan Hotel and Residences" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 175 : 125;
    } else if (
      formData.from === "Flamboyan Hotel and Residences" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (
      formData.from === "GR Solaris Lighthouse Los Cabos" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 115 : 65;
    } else if (
      formData.from === "GR Solaris Lighthouse Los Cabos" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 130 : 80;
    } else if (
      formData.from === "GR Solaris Lighthouse Los Cabos" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 125 : 75;
    } else if (
      formData.from === "GR Solaris Lighthouse Los Cabos" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 175 : 125;
    } else if (
      formData.from === "GR Solaris Lighthouse Los Cabos" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (formData.from === "Hyatt Place" && vehicles === "Suburban") {
      basePrice = isReturn ? 115 : 65;
    } else if (formData.from === "Hyatt Place" && vehicles === "Escalade") {
      basePrice = isReturn ? 130 : 80;
    } else if (formData.from === "Hyatt Place" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 125 : 75;
    } else if (
      formData.from === "Hyatt Place" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 175 : 125;
    } else if (formData.from === "Hyatt Place" && vehicles === "Sprinter large") {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (formData.from === "Hyatt Ziva" && vehicles === "Suburban") {
      basePrice = isReturn ? 115 : 65;
    } else if (formData.from === "Hyatt Ziva" && vehicles === "Escalade") {
      basePrice = isReturn ? 130 : 80;
    } else if (formData.from === "Hyatt Ziva" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 125 : 75;
    } else if (
      formData.from === "Hyatt Ziva" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 175 : 125;
    } else if (formData.from === "Hyatt Ziva" && vehicles === "Sprinter large") {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (formData.from === "Krystal Grand Los Cabos" && vehicles === "Suburban") {
      basePrice = isReturn ? 115 : 65;
    } else if (
      formData.from === "Krystal Grand Los Cabos" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 130 : 80;
    } else if (
      formData.from === "Krystal Grand Los Cabos" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 125 : 75;
    } else if (
      formData.from === "Krystal Grand Los Cabos" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 175 : 125;
    } else if (
      formData.from === "Krystal Grand Los Cabos" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (formData.from === "La Jolla" && vehicles === "Suburban") {
      basePrice = isReturn ? 115 : 65;
    } else if (formData.from === "La Jolla" && vehicles === "Escalade") {
      basePrice = isReturn ? 130 : 80;
    } else if (formData.from === "La Jolla" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 125 : 75;
    } else if (formData.from === "La Jolla" && vehicles === "Sprinter mid-size") {
      basePrice = isReturn ? 175 : 125;
    } else if (formData.from === "La Jolla" && vehicles === "Sprinter large") {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (formData.from === "La Jolla" && vehicles === "Suburban") {
      basePrice = isReturn ? 115 : 65;
    } else if (formData.from === "La Jolla" && vehicles === "Escalade") {
      basePrice = isReturn ? 130 : 80;
    } else if (formData.from === "La Jolla" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 125 : 75;
    } else if (formData.from === "La Jolla" && vehicles === "Sprinter mid-size") {
      basePrice = isReturn ? 175 : 125;
    } else if (formData.from === "La Jolla" && vehicles === "Sprinter large") {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (formData.from === "Las Mananitas" && vehicles === "Suburban") {
      basePrice = isReturn ? 115 : 65;
    } else if (formData.from === "Las Mananitas" && vehicles === "Escalade") {
      basePrice = isReturn ? 130 : 80;
    } else if (formData.from === "Las Mananitas" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 125 : 75;
    } else if (
      formData.from === "Las Mananitas" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 175 : 125;
    } else if (
      formData.from === "Las Mananitas" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (formData.from === "Las Olas" && vehicles === "Suburban") {
      basePrice = isReturn ? 115 : 65;
    } else if (formData.from === "Las Olas" && vehicles === "Escalade") {
      basePrice = isReturn ? 130 : 80;
    } else if (formData.from === "Las Olas" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 125 : 75;
    } else if (formData.from === "Las Olas" && vehicles === "Sprinter mid-size") {
      basePrice = isReturn ? 175 : 125;
    } else if (formData.from === "Las Olas" && vehicles === "Sprinter large") {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (formData.from === "Marisol" && vehicles === "Suburban") {
      basePrice = isReturn ? 115 : 65;
    } else if (formData.from === "Marisol" && vehicles === "Escalade") {
      basePrice = isReturn ? 130 : 80;
    } else if (formData.from === "Marisol" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 125 : 75;
    } else if (formData.from === "Marisol" && vehicles === "Sprinter mid-size") {
      basePrice = isReturn ? 175 : 125;
    } else if (formData.from === "Marisol" && vehicles === "Sprinter large") {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (formData.from === "Mira Vista" && vehicles === "Suburban") {
      basePrice = isReturn ? 115 : 65;
    } else if (formData.from === "Mira Vista" && vehicles === "Escalade") {
      basePrice = isReturn ? 130 : 80;
    } else if (formData.from === "Mira Vista" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 125 : 75;
    } else if (
      formData.from === "Mira Vista" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 175 : 125;
    } else if (formData.from === "Mira Vista" && vehicles === "Sprinter large") {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (formData.from === "Mykonos" && vehicles === "Suburban") {
      basePrice = isReturn ? 115 : 65;
    } else if (formData.from === "Mykonos" && vehicles === "Escalade") {
      basePrice = isReturn ? 130 : 80;
    } else if (formData.from === "Mykonos" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 125 : 75;
    } else if (formData.from === "Mykonos" && vehicles === "Sprinter mid-size") {
      basePrice = isReturn ? 175 : 125;
    } else if (formData.from === "Mykonos" && vehicles === "Sprinter large") {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (formData.from === "Park Royal Los Cabos" && vehicles === "Suburban") {
      basePrice = isReturn ? 115 : 65;
    } else if (
      formData.from === "Park Royal Los Cabos" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 130 : 80;
    } else if (
      formData.from === "Park Royal Los Cabos" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 125 : 75;
    } else if (
      formData.from === "Park Royal Los Cabos" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 175 : 125;
    } else if (
      formData.from === "Park Royal Los Cabos" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 195 : 145;
    }
    //------
    if (formData.from === "Posada Real" && vehicles === "Suburban") {
      basePrice = isReturn ? 115 : 65;
    } else if (formData.from === "Posada Real" && vehicles === "Escalade") {
      basePrice = isReturn ? 130 : 80;
    } else if (formData.from === "Posada Real" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 125 : 75;
    } else if (
      formData.from === "Posada Real" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 175 : 125;
    } else if (formData.from === "Posada Real" && vehicles === "Sprinter large") {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (formData.from === "Royal Decameron" && vehicles === "Suburban") {
      basePrice = isReturn ? 115 : 65;
    } else if (formData.from === "Royal Decameron" && vehicles === "Escalade") {
      basePrice = isReturn ? 130 : 80;
    } else if (
      formData.from === "Royal Decameron" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 125 : 75;
    } else if (
      formData.from === "Royal Decameron" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 175 : 125;
    } else if (
      formData.from === "Royal Decameron" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (formData.from === "Royal Solaris" && vehicles === "Suburban") {
      basePrice = isReturn ? 115 : 65;
    } else if (formData.from === "Royal Solaris" && vehicles === "Escalade") {
      basePrice = isReturn ? 130 : 80;
    } else if (formData.from === "Royal Solaris" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 125 : 75;
    } else if (
      formData.from === "Royal Solaris" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 175 : 125;
    } else if (
      formData.from === "Royal Solaris" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (formData.from === "Sampaguita" && vehicles === "Suburban") {
      basePrice = isReturn ? 115 : 65;
    } else if (formData.from === "Sampaguita" && vehicles === "Escalade") {
      basePrice = isReturn ? 130 : 80;
    } else if (formData.from === "Sampaguita" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 125 : 75;
    } else if (
      formData.from === "Sampaguita" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 175 : 125;
    } else if (formData.from === "Sampaguita" && vehicles === "Sprinter large") {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (formData.from === "Six Two Four Hotel" && vehicles === "Suburban") {
      basePrice = isReturn ? 115 : 65;
    } else if (
      formData.from === "Six Two Four Hotel" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 130 : 80;
    } else if (
      formData.from === "Six Two Four Hotel" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 125 : 75;
    } else if (
      formData.from === "Six Two Four Hotel" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 175 : 125;
    } else if (
      formData.from === "Six Two Four Hotel" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (
      formData.from === "Soleado Beach & Spa Resort" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 115 : 65;
    } else if (
      formData.from === "Soleado Beach & Spa Resort" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 130 : 80;
    } else if (
      formData.from === "Soleado Beach & Spa Resort" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 125 : 75;
    } else if (
      formData.from === "Soleado Beach & Spa Resort" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 175 : 125;
    } else if (
      formData.from === "Soleado Beach & Spa Resort" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (formData.from === "Suites Las Palmas" && vehicles === "Suburban") {
      basePrice = isReturn ? 115 : 65;
    } else if (formData.from === "Suites Las Palmas" && vehicles === "Escalade") {
      basePrice = isReturn ? 130 : 80;
    } else if (
      formData.from === "Suites Las Palma" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 125 : 75;
    } else if (
      formData.from === "Suites Las Palma" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 175 : 125;
    } else if (
      formData.from === "Suites Las Palma" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (
      formData.from === "The Grand Mayan at Vidanta Los Cabos" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 115 : 65;
    } else if (
      formData.from === "The Grand Mayan at Vidanta Los Cabos" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 130 : 80;
    } else if (
      formData.from === "The Grand Mayan at Vidanta Los Cabos" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 125 : 75;
    } else if (
      formData.from === "The Grand Mayan at Vidanta Los Cabos" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 175 : 125;
    } else if (
      formData.from === "The Grand Mayan at Vidanta Los Cabos" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (
      formData.from === "Tropicana Los Cabo, Tapestry Collection by Hilton" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 115 : 65;
    } else if (
      formData.from === "Tropicana Los Cabo, Tapestry Collection by Hilton" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 130 : 80;
    } else if (
      formData.from === "Tropicana Los Cabo, Tapestry Collection by Hilton" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 125 : 75;
    } else if (
      formData.from === "Tropicana Los Cabo, Tapestry Collection by Hilton" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 175 : 125;
    } else if (
      formData.from === "Tropicana Los Cabo, Tapestry Collection by Hilton" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (
      formData.from === "The Grand Mayan at Vidanta Los Cabos" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 115 : 65;
    } else if (
      formData.from === "The Grand Mayan at Vidanta Los Cabos" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 130 : 80;
    } else if (
      formData.from === "The Grand Mayan at Vidanta Los Cabos" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 125 : 75;
    } else if (
      formData.from === "The Grand Mayan at Vidanta Los Cabos" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 175 : 125;
    } else if (
      formData.from === "The Grand Mayan at Vidanta Los Cabos" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (formData.from === "Viceroy Los Cabos" && vehicles === "Suburban") {
      basePrice = isReturn ? 115 : 65;
    } else if (formData.from === "Viceroy Los Cabos" && vehicles === "Escalade") {
      basePrice = isReturn ? 130 : 80;
    } else if (
      formData.from === "Viceroy Los Cabos" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 125 : 75;
    } else if (
      formData.from === "Viceroy Los Cabos" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 175 : 125;
    } else if (
      formData.from === "Viceroy Los Cabos" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (formData.from === "WorldMatk Coral Baja" && vehicles === "Suburban") {
      basePrice = isReturn ? 115 : 65;
    } else if (
      formData.from === "WorldMatk Coral Baja" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 130 : 80;
    } else if (
      formData.from === "WorldMatk Coral Baja" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 125 : 75;
    } else if (
      formData.from === "WorldMatk Coral Baja" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 175 : 125;
    } else if (
      formData.from === "WorldMatk Coral Baja" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 195 : 145;
    }

    //------
    if (
      formData.from === "--- Puertos Los Cabos ---" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 145 : 75;
    } else if (
      formData.from === "--- Puertos Los Cabos ---" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 160 : 90;
    } else if (
      formData.from === "--- Puertos Los Cabos ---" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 155 : 85;
    } else if (
      formData.from === "--- Puertos Los Cabos ---" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 205 : 135;
    } else if (
      formData.from === "--- Puertos Los Cabos ---" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 225 : 155;
    }

    //------
    if (formData.from === "Acre Resort" && vehicles === "Suburban") {
      basePrice = isReturn ? 145 : 75;
    } else if (formData.from === "Acre Resort" && vehicles === "Escalade") {
      basePrice = isReturn ? 160 : 90;
    } else if (formData.from === "Acre Resort" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 155 : 85;
    } else if (
      formData.from === "Acre Resort" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 205 : 135;
    } else if (formData.from === "Acre Resort" && vehicles === "Sprinter large") {
      basePrice = isReturn ? 225 : 155;
    }

    //------
    if (formData.from === "Flora Farms" && vehicles === "Suburban") {
      basePrice = isReturn ? 145 : 75;
    } else if (formData.from === "Flora Farms" && vehicles === "Escalade") {
      basePrice = isReturn ? 160 : 90;
    } else if (formData.from === "Flora Farms" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 155 : 85;
    } else if (
      formData.from === "Flora Farms" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 205 : 135;
    } else if (formData.from === "Flora Farms" && vehicles === "Sprinter large") {
      basePrice = isReturn ? 225 : 155;
    }

    //------
    if (formData.from === "Hotel El Ganzo" && vehicles === "Suburban") {
      basePrice = isReturn ? 145 : 75;
    } else if (formData.from === "Hotel El Ganzo" && vehicles === "Escalade") {
      basePrice = isReturn ? 160 : 90;
    } else if (
      formData.from === "Hotel El Ganzo" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 155 : 85;
    } else if (
      formData.from === "Hotel El Ganzo" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 205 : 135;
    } else if (
      formData.from === "Hotel El Ganzo" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 225 : 155;
    }

    //------
    if (
      formData.from === "JW Marriot Los Cabos Beach Resort & Spa" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 145 : 75;
    } else if (
      formData.from === "JW Marriot Los Cabos Beach Resort & Spa" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 160 : 90;
    } else if (
      formData.from === "JW Marriot Los Cabos Beach Resort & Spa" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 155 : 85;
    } else if (
      formData.from === "JW Marriot Los Cabos Beach Resort & Spa" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 205 : 135;
    } else if (
      formData.from === "JW Marriot Los Cabos Beach Resort & Spa" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 225 : 155;
    }

    //------
    if (formData.from === "La Marina Inn" && vehicles === "Suburban") {
      basePrice = isReturn ? 145 : 75;
    } else if (formData.from === "La Marina Inn" && vehicles === "Escalade") {
      basePrice = isReturn ? 160 : 90;
    } else if (formData.from === "La Marina Inn" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 155 : 85;
    } else if (
      formData.from === "La Marina Inn" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 205 : 135;
    } else if (
      formData.from === "La Marina Inn" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 225 : 155;
    }

    //------
    if (
      formData.from === "Puerto Los Cabos Residential Area" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 145 : 75;
    } else if (
      formData.from === "Puerto Los Cabos Residential Area" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 160 : 90;
    } else if (
      formData.from === "Puerto Los Cabos Residential Area" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 155 : 85;
    } else if (
      formData.from === "Puerto Los Cabos Residential Area" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 205 : 135;
    } else if (
      formData.from === "Puerto Los Cabos Residential Area" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 225 : 155;
    }

    //------
    if (
      formData.from === "Secrets Puertos Los Cabos" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 145 : 75;
    } else if (
      formData.from === "Secrets Puertos Los Cabos" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 160 : 90;
    } else if (
      formData.from === "Secrets Puertos Los Cabos" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 155 : 85;
    } else if (
      formData.from === "Secrets Puertos Los Cabos" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 205 : 135;
    } else if (
      formData.from === "Secrets Puertos Los Cabos" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 225 : 155;
    }

    //------
    if (
      formData.from === "Zadun, a Ritz-Carlton Reserve" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 145 : 75;
    } else if (
      formData.from === "Zadun, a Ritz-Carlton Reserve" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 160 : 90;
    } else if (
      formData.from === "Zadun, a Ritz-Carlton Reserve" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 155 : 85;
    } else if (
      formData.from === "Zadun, a Ritz-Carlton Reserve" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 205 : 135;
    } else if (
      formData.from === "Zadun, a Ritz-Carlton Reserve" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 225 : 155;
    }

    //------
    if (formData.from === "--- East Cape Side ---" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 85;
    } else if (
      formData.from === "--- East Cape Side ---" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 100;
    } else if (
      formData.from === "--- East Cape Side ---" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 95;
    } else if (
      formData.from === "--- East Cape Side ---" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 145;
    } else if (
      formData.from === "--- East Cape Side ---" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 165;
    }

    //------
    if (formData.from === "El Encanto de la Laguna" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 85;
    } else if (
      formData.from === "El Encanto de la Laguna" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 100;
    } else if (
      formData.from === "El Encanto de la Laguna" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 95;
    } else if (
      formData.from === "El Encanto de la Laguna" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 145;
    } else if (
      formData.from === "El Encanto de la Laguna" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 165;
    }

    //------
    if (formData.from === "--- Corridor ---" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 75;
    } else if (formData.from === "--- Corridor ---" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "--- Corridor ---" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "--- Corridor ---" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "--- Corridor ---" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Chileno Bay Resort & Residences" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 75;
    } else if (
      formData.from === "Chileno Bay Resort & Residences" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Chileno Bay Resort & Residences" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Chileno Bay Resort & Residences" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Chileno Bay Resort & Residences" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Dreams" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 75;
    } else if (formData.from === "Dreams" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (formData.from === "Dreams" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 165 : 85;
    } else if (formData.from === "Dreams" && vehicles === "Sprinter mid-size") {
      basePrice = isReturn ? 215 : 135;
    } else if (formData.from === "Dreams" && vehicles === "Sprinter large") {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "El Dorado Residentials Area" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 75;
    } else if (
      formData.from === "El Dorado Residentials Area" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "El Dorado Residentials Area" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "El Dorado Residentials Area" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "El Dorado Residentials Area" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Garza Blanca Resort & Spa" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 75;
    } else if (
      formData.from === "Garza Blanca Resort & Spa" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Garza Blanca Resort & Spa" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Garza Blanca Resort & Spa" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Garza Blanca Resort & Spa" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Grand Velas Boutique Los Cabos" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 75;
    } else if (
      formData.from === "Grand Velas Boutique Los Cabos" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Grand Velas Boutique Los Cabos" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Grand Velas Boutique Los Cabos" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Grand Velas Boutique Los Cabos" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Grand Velas Los Cabos" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 75;
    } else if (
      formData.from === "Grand Velas Los Cabos" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Grand Velas Los Cabos" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Grand Velas Los Cabos" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Grand Velas Los Cabos" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }
    //------
    if (formData.from === "Grand Velas Los Cabos" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 75;
    } else if (
      formData.from === "Grand Velas Los Cabos" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Grand Velas Los Cabos" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Grand Velas Los Cabos" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Grand Velas Los Cabos" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Hampton Inn & Suites by Hilton" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 75;
    } else if (
      formData.from === "Hampton Inn & Suites by Hilton" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Hampton Inn & Suites by Hilton" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Hampton Inn & Suites by Hilton" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Hampton Inn & Suites by Hilton" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Hilton Los Cabos" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 75;
    } else if (formData.to === "Hilton Los Cabos" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Hilton Los Cabos" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Hilton Los Cabos" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Hilton Los Cabos" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "La Pacifica Los Cabos by Hilton Grand Vocations" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 75;
    } else if (
      formData.from === "La Pacifica Los Cabos by Hilton Grand Vocations" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "La Pacifica Los Cabos by Hilton Grand Vocations" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "La Pacifica Los Cabos by Hilton Grand Vocations" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "La Pacifica Los Cabos by Hilton Grand Vocations" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Las Ventanas al Paraiso" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 75;
    } else if (
      formData.from === "Las Ventanas al Paraiso" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Las Ventanas al Paraiso" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Las Ventanas al Paraiso" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Las Ventanas al Paraiso" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Le Blanc spa Resort Los Cabos" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 75;
    } else if (
      formData.from === "Le Blanc spa Resort Los Cabos" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Le Blanc spa Resort Los Cabos" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Le Blanc spa Resort Los Cabos" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Le Blanc spa Resort Los Cabos" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Mar del Cabo" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 75;
    } else if (formData.from === "Mar del Cabo" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (formData.from === "Mar del Cabo" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Mar del Cabo" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Mar del Cabo" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Maravilla Los Cabos" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 75;
    } else if (
      formData.from === "Maravilla Los Cabos" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Maravilla Los Cabos" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Maravilla Los Cabos" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Maravilla Los Cabos" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Montage Los Cabos" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 75;
    } else if (formData.from === "Montage Los Cabos" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Montage Los Cabos" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Montage Los Cabos" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Montage Los Cabos" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "One&Only Palmilla" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 75;
    } else if (formData.from === "One&Only Palmilla" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "One&Only Palmilla" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "One&Only Palmilla" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "One&Only Palmilla" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Palmilla Residential Area" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 75;
    } else if (
      formData.from === "Palmilla Residential Area" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Palmilla Residential Area" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Palmilla Residential Area" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Palmilla Residential Area" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Paradisus" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 75;
    } else if (formData.from === "Paradisus" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (formData.from === "Paradisus" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Paradisus" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (formData.from === "Paradisus" && vehicles === "Sprinter large") {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Querencia Residential Area" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 75;
    } else if (
      formData.from === "Querencia Residential Area" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Querencia Residential Area" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Querencia Residential Area" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Querencia Residential Area" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Solaz" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 75;
    } else if (formData.from === "Solaz" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (formData.from === "Solaz" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 165 : 85;
    } else if (formData.from === "Solaz" && vehicles === "Sprinter mid-size") {
      basePrice = isReturn ? 215 : 135;
    } else if (formData.from === "Solaz" && vehicles === "Sprinter large") {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "The Westin Resort & Spa" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 75;
    } else if (
      formData.from === "The Westin Resort & Spa" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "The Westin Resort & Spa" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "The Westin Resort & Spa" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "The Westin Resort & Spa" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Villa La Valencia Beach Resort & Spa" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 75;
    } else if (
      formData.from === "Villa La Valencia Beach Resort & Spa" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Villa La Valencia Beach Resort & Spa" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Villa La Valencia Beach Resort & Spa" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Villa La Valencia Beach Resort & Spa" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Zoetry Casa De Mar Los Cabos" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 75;
    } else if (
      formData.from === "Zoetry Casa De Mar Los Cabos" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Zoetry Casa De Mar Los Cabos" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Zoetry Casa De Mar Los Cabos" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Zoetry Casa De Mar Los Cabos" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "--- Cabo San Lucas ---" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "--- Cabo San Lucas ---" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 100;
    } else if (
      formData.from === "--- Cabo San Lucas ---" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 95;
    } else if (
      formData.from === "--- Cabo San Lucas ---" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 145;
    } else if (
      formData.from === "--- Cabo San Lucas ---" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 165;
    }

    //------
    if (formData.from === "1 Homes Preview Cabo" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "1 Homes Preview Cabo" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "1 Homes Preview Cabo" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "1 Homes Preview Cabo" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "1 Homes Preview Cabo" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Bahia Hotel and Beach House" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Bahia Hotel and Beach House" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Bahia Hotel and Beach House" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Bahia Hotel and Beach House" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Bahia Hotel and Beach House" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Breathless Cabo San Lucas Resort & Spa" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Breathless Cabo San Lucas Resort & Spa" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Breathless Cabo San Lucas Resort & Spa" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Breathless Cabo San Lucas Resort & Spa" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Breathless Cabo San Lucas Resort & Spa" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Bungalows" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Bungalows" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (formData.from === "Bungalows" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Bungalows" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (formData.from === "Bungalows" && vehicles === "Sprinter large") {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Cabo Bello Residential Area" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Cabo Bello Residential Area" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Cabo Bello Residential Area" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Cabo Bello Residential Area" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Cabo Bello Residential Area" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Cabo Del Sol Residential Area" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Cabo Del Sol Residential Area" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Cabo Del Sol Residential Area" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Cabo Del Sol Residential Area" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Cabo Del Sol Residential Area" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Cabo Inn" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Cabo Inn" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (formData.from === "Cabo Inn" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 165 : 85;
    } else if (formData.from === "Cabo Inn" && vehicles === "Sprinter mid-size") {
      basePrice = isReturn ? 215 : 135;
    } else if (formData.from === "Cabo Inn" && vehicles === "Sprinter large") {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Cabo Vista" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Cabo Vista" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (formData.from === "Cabo Vista" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Cabo Vista" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (formData.from === "Cabo Vista" && vehicles === "Sprinter large") {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Casa Dorada At Medano Beach" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Casa Dorada At Medano Beach" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Casa Dorada At Medano Beach" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Casa Dorada At Medano Beach" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Casa Dorada At Medano Beach" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Casa Pescador" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Casa Pescador" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (formData.from === "Casa Pescador" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Casa Pescador" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Casa Pescador" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Club Cascadas" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Club Cascadas" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (formData.from === "Club Cascadas" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Club Cascadas" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Club Cascadas" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Confort inn & Suites Los Cabos" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Confort inn & Suites Los Cabos" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Confort inn & Suites Los Cabos" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Confort inn & Suites Los Cabos" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Confort inn & Suites Los Cabos" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Confort inn & Suites Los Cabos" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Confort inn & Suites Los Cabos" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Confort inn & Suites Los Cabos" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Confort inn & Suites Los Cabos" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Confort inn & Suites Los Cabos" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "El Encanto All Inclusive Resort at Hacienda Encantada" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "El Encanto All Inclusive Resort at Hacienda Encantada" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "El Encanto All Inclusive Resort at Hacienda Encantada" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "El Encanto All Inclusive Resort at Hacienda Encantada" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "El Encanto All Inclusive Resort at Hacienda Encantada" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Esperanza, an Auberge Resort & Spa" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Esperanza, an Auberge Resort & Spa" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Esperanza, an Auberge Resort & Spa" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Esperanza, an Auberge Resort & Spa" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Esperanza, an Auberge Resort & Spa" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Estancia Real" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Estancia Real" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (formData.from === "Estancia Real" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Estancia Real" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Estancia Real" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Fairfield Inn By Marriott" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Fairfield Inn By Marriott" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Fairfield Inn By Marriott" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Fairfield Inn By Marriott" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Fairfield Inn By Marriott" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Four Seasons Cabo Del Sol" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Four Seasons Cabo Del Sol" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Four Seasons Cabo Del Sol" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Four Seasons Cabo Del Sol" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Four Seasons Cabo Del Sol" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Grand Fiesta Americana" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Grand Fiesta Americana" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Grand Fiesta Americana" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Grand Fiesta Americana" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Grand Fiesta Americana" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Grand Solmar Lands End Resort" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Grand Solmar Lands End Resort" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Grand Solmar Lands End Resort" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Grand Solmar Lands End Resort" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Grand Solmar Lands End Resort" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Hacienda Beach" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Hacienda Beach" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Hacienda Beach" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Hacienda Beach" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Hacienda Beach" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Hacienda Del Mar" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Hacienda Del Mar" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Hacienda Del Mar" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Hacienda Del Mar" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Hacienda Del Mar" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Hacienda Encantada Resort & Spa" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Hacienda Encantada Resort & Spa" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Hacienda Encantada Resort & Spa" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Hacienda Encantada Resort & Spa" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Hacienda Encantada Resort & Spa" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Holiday Inn Express" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Holiday Inn Express" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Holiday Inn Express" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Holiday Inn Express" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Holiday Inn Express" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Hotel Castillo Blarney" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Hotel Castillo Blarney" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Hotel Castillo Blarney" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Hotel Castillo Blarney" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Hotel Castillo Blarney" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Live Aqua Private Residences Los Cabos" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Live Aqua Private Residences Los Cabos" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Live Aqua Private Residences Los Cabos" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Live Aqua Private Residences Los Cabos" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Live Aqua Private Residences Los Cabos" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Los Cabos Golf Resort" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Los Cabos Golf Resort" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Los Cabos Golf Resort" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Los Cabos Golf Resort" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Los Cabos Golf Resort" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Los Milagros" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Los Milagros" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (formData.from === "Los Milagros" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Los Milagros" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Los Milagros" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Los Patios" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Los Patios" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (formData.from === "Los Patios" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Los Patios" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (formData.from === "Los Patios" && vehicles === "Sprinter large") {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Marea Los Cabos" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Marea Los Cabos" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Marea Los Cabos" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Marea Los Cabos" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Marea Los Cabos" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Marina Cabo Plaza" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Marina Cabo Plaza" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Marina Cabo Plaza" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Marina Cabo Plaza" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Marina Cabo Plaza" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Marina Fiesta" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Marina Fiesta" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (formData.from === "Marina Fiesta" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Marina Fiesta" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Marina Fiesta" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Marina Sol" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Marina Sol" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (formData.from === "Marina Sol" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Marina Sol" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (formData.from === "Marina Sol" && vehicles === "Sprinter large") {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Marina View Villas" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Marina View Villas" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Marina View Villas" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Marina View Villas" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Marina View Villas" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Mayan Monkey Hostel Los Cabos" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Mayan Monkey Hostel Los Cabos" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Mayan Monkey Hostel Los Cabos" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Mayan Monkey Hostel Los Cabos" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Mayan Monkey Hostel Los Cabos" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Me Cabo" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Me Cabo" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (formData.from === "Me Cabo" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 165 : 85;
    } else if (formData.from === "Me Cabo" && vehicles === "Sprinter mid-size") {
      basePrice = isReturn ? 215 : 135;
    } else if (formData.from === "Me Cabo" && vehicles === "Sprinter large") {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Medano Hotel and Suites" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Medano Hotel and Suites" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Medano Hotel and Suites" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Medano Hotel and Suites" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Medano Hotel and Suites" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Melissa's Apartment" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Melissa's Apartment" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Melissa's Apartment" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Melissa's Apartment" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Melissa's Apartment" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Misiones Del Cabo" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Misiones Del Cabo" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Misiones Del Cabo" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Misiones Del Cabo" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Misiones Del Cabo" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "One Medano Beach" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "One Medano Beach" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "One Medano Beach" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "One Medano Beach" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "One Medano Beach" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Pedregal Residential Area" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Pedregal Residential Area" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Pedregal Residential Area" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Pedregal Residential Area" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Pedregal Residential Area" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Playa Grande Resort & Spa" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Playa Grande Resort & Spa" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Playa Grande Resort & Spa" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Playa Grande Resort & Spa" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Playa Grande Resort & Spa" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Plaza Nautica Condominiums Hotel" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Plaza Nautica Condominiums Hotel" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Plaza Nautica Condominiums Hotel" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Plaza Nautica Condominiums Hotel" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Plaza Nautica Condominiums Hotel" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Portofino Condos In Pedregal" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Portofino Condos In Pedregal" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Portofino Condos In Pedregal" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Portofino Condos In Pedregal" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Portofino Condos In Pedregal" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Pueblo Bonito Los Cabos Blanco" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Pueblo Bonito Los Cabos Blanco" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Pueblo Bonito Los Cabos Blanco" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Pueblo Bonito Los Cabos Blanco" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Pueblo Bonito Los Cabos Blanco" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Pueblo Bonito Rose" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Pueblo Bonito Rose" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Pueblo Bonito Rose" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Pueblo Bonito Rose" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Pueblo Bonito Rose" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Puerta Cabos Village" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Puerta Cabos Village" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Puerta Cabos Village" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Puerta Cabos Village" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Puerta Cabos Village" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Puerta Del Sol" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Puerta Del Sol" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Puerta Del Sol" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Puerta Del Sol" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Puerta Del Sol" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Punta Ballena Residential Area" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Punta Ballena Residential Area" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Punta Ballena Residential Area" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Punta Ballena Residential Area" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Punta Ballena Residential Area" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Riu Palace Baja California" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Riu Palace Baja California" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Riu Palace Baja California" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Riu Palace Baja California" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Riu Palace Baja California" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Riu Palace Cabo San Lucas" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Riu Palace Cabo San Lucas" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Riu Palace Cabo San Lucas" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Riu Palace Cabo San Lucas" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Riu Palace Cabo San Lucas" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Riu Santa Fe" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Riu Santa Fe" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (formData.from === "Riu Santa Fe" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Riu Santa Fe" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Riu Santa Fe" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "San Angel Suites" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "San Angel Suites" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "San Angel Suites" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "San Angel Suites" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "San Angel Suites" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Sandos Finisterra" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Sandos Finisterra" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Sandos Finisterra" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Sandos Finisterra" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Sandos Finisterra" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Seven Crown" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Seven Crown" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (formData.from === "Seven Crown" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Seven Crown" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (formData.from === "Seven Crown" && vehicles === "Sprinter large") {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Siesta Suites" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Siesta Suites" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (formData.from === "Siesta Suites" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Siesta Suites" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Siesta Suites" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Sirena del Mar" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Sirena del Mar" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Sirena del Mar" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Sirena del Mar" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Sirena del Mar" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Solmar" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Solmar" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (formData.from === "Solmar" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 165 : 85;
    } else if (formData.from === "Solmar" && vehicles === "Sprinter mid-size") {
      basePrice = isReturn ? 215 : 135;
    } else if (formData.from === "Solmar" && vehicles === "Sprinter large") {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Sunrock Hotel & Residences" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Sunrock Hotel & Residences" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Sunrock Hotel & Residences" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Sunrock Hotel & Residences" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Sunrock Hotel & Residences" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Terrasol" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Terrasol" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (formData.from === "Terrasol" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 165 : 85;
    } else if (formData.from === "Terrasol" && vehicles === "Sprinter mid-size") {
      basePrice = isReturn ? 215 : 135;
    } else if (formData.from === "Terrasol" && vehicles === "Sprinter large") {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Tesoro Los Cabos" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Tesoro Los Cabos" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Tesoro Los Cabos" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Tesoro Los Cabos" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Tesoro Los Cabos" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "The Cape Thompson Hotel" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "The Cape Thompson Hotel" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "The Cape Thompson Hotel" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "The Cape Thompson Hotel" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "The Cape Thompson Hotel" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "The Paraiso Residences" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "The Paraiso Residences" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "The Paraiso Residences" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "The Paraiso Residences" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "The Paraiso Residences" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "The Residences at La Vista" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "The Residences at La Vista" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "The Residences at La Vista" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "The Residences at La Vista" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "The Residences at La Vista" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Tezal Residential Area" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Tezal Residential Area" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Tezal Residential Area" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Tezal Residential Area" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Tezal Residential Area" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Villa Del Arco" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Villa Del Arco" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Villa Del Arco" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Villa Del Arco" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Villa Del Arco" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Villa Del Palmar" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Villa Del Palmar" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Villa Del Palmar" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Villa Del Palmar" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Villa Del Palmar" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Villa La Estancia" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Villa La Estancia" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Villa La Estancia" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Villa La Estancia" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Villa La Estancia" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Villa Serena" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Villa Serena" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (formData.from === "Villa Serena" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Villa Serena" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Villa Serena" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Vista Encantada Spa Resort & Residences" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Vista Encantada Spa Resort & Residences" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Vista Encantada Spa Resort & Residences" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Vista Encantada Spa Resort & Residences" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Vista Encantada Spa Resort & Residences" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Vista Vela Condos" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Vista Vela Condos" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Vista Vela Condos" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Vista Vela Condos" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Vista Vela Condos" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (formData.from === "Vista Vela Condos" && vehicles === "Suburban") {
      basePrice = isReturn ? 155 : 80;
    } else if (formData.from === "Vista Vela Condos" && vehicles === "Escalade") {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Vista Vela Condos" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Vista Vela Condos" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Vista Vela Condos" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "Waldorf Astoria Los Cabos Pedregal" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 155 : 80;
    } else if (
      formData.from === "Waldorf Astoria Los Cabos Pedregal" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 170 : 90;
    } else if (
      formData.from === "Waldorf Astoria Los Cabos Pedregal" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 165 : 85;
    } else if (
      formData.from === "Waldorf Astoria Los Cabos Pedregal" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 215 : 135;
    } else if (
      formData.from === "Waldorf Astoria Los Cabos Pedregal" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 235 : 155;
    }

    //------
    if (
      formData.from === "--- Cabo San Lucas Pacific Side ---" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 170 : 95;
    } else if (
      formData.from === "--- Cabo San Lucas Pacific Side ---" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 185 : 110;
    } else if (
      formData.from === "--- Cabo San Lucas Pacific Side ---" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 180 : 105;
    } else if (
      formData.from === "--- Cabo San Lucas Pacific Side ---" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 230 : 155;
    } else if (
      formData.from === "--- Cabo San Lucas Pacific Side ---" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 250 : 175;
    }

    //------
    if (formData.from === "Diamante" && vehicles === "Suburban") {
      basePrice = isReturn ? 170 : 95;
    } else if (formData.from === "Diamante" && vehicles === "Escalade") {
      basePrice = isReturn ? 185 : 110;
    } else if (formData.from === "Diamante" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 180 : 105;
    } else if (formData.from === "Diamante" && vehicles === "Sprinter mid-size") {
      basePrice = isReturn ? 230 : 155;
    } else if (formData.from === "Diamante" && vehicles === "Sprinter large") {
      basePrice = isReturn ? 250 : 175;
    }

    //------
    if (
      formData.from === "Grand Solmar Pacific Dunes Golf and Spa" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 170 : 95;
    } else if (
      formData.from === "Grand Solmar Pacific Dunes Golf and Spa" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 185 : 110;
    } else if (
      formData.from === "Grand Solmar Pacific Dunes Golf and Spa" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 180 : 105;
    } else if (
      formData.from === "Grand Solmar Pacific Dunes Golf and Spa" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 230 : 155;
    } else if (
      formData.from === "Grand Solmar Pacific Dunes Golf and Spa" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 250 : 175;
    }

    //------
    if (
      formData.from === "Montecristo Residential Area" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 170 : 95;
    } else if (
      formData.from === "Montecristo Residential Area" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 185 : 110;
    } else if (
      formData.from === "Montecristo Residential Area" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 180 : 105;
    } else if (
      formData.from === "Montecristo Residential Area" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 230 : 155;
    } else if (
      formData.from === "Montecristo Residential Area" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 250 : 175;
    }

    //------
    if (formData.from === "Nobu Hotel Los Cabos" && vehicles === "Suburban") {
      basePrice = isReturn ? 170 : 95;
    } else if (
      formData.from === "Nobu Hotel Los Cabos" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 185 : 110;
    } else if (
      formData.from === "Nobu Hotel Los Cabos" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 180 : 105;
    } else if (
      formData.from === "Nobu Hotel Los Cabos" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 230 : 155;
    } else if (
      formData.from === "Nobu Hotel Los Cabos" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 250 : 175;
    }

    //------
    if (formData.from === "Pueblo Bonito Pacifica" && vehicles === "Suburban") {
      basePrice = isReturn ? 170 : 95;
    } else if (
      formData.from === "Pueblo Bonito Pacifica" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 185 : 110;
    } else if (
      formData.from === "Pueblo Bonito Pacifica" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 180 : 105;
    } else if (
      formData.from === "Pueblo Bonito Pacifica" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 230 : 155;
    } else if (
      formData.from === "Pueblo Bonito Pacifica" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 250 : 175;
    }

    //------
    if (
      formData.from === "Pueblo Bonito Sunset Beach" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 170 : 95;
    } else if (
      formData.from === "Pueblo Bonito Sunset Beach" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 185 : 110;
    } else if (
      formData.from === "Pueblo Bonito Sunset Beach" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 180 : 105;
    } else if (
      formData.from === "Pueblo Bonito Sunset Beach" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 230 : 155;
    } else if (
      formData.from === "Pueblo Bonito Sunset Beach" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 250 : 175;
    }

    //------
    if (formData.from === "Quivira Residential" && vehicles === "Suburban") {
      basePrice = isReturn ? 170 : 95;
    } else if (
      formData.from === "Quivira Residential" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 185 : 110;
    } else if (
      formData.from === "Quivira Residential" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 180 : 105;
    } else if (
      formData.from === "Quivira Residential" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 230 : 155;
    } else if (
      formData.from === "Quivira Residential" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 250 : 175;
    }

    //------
    if (formData.from === "The Hard Rock Hotel" && vehicles === "Suburban") {
      basePrice = isReturn ? 170 : 95;
    } else if (
      formData.from === "The Hard Rock Hotel" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 185 : 110;
    } else if (
      formData.from === "The Hard Rock Hotel" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 180 : 105;
    } else if (
      formData.from === "The Hard Rock Hotel" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 230 : 155;
    } else if (
      formData.from === "The Hard Rock Hotel" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 250 : 175;
    }

    //------
    if (
      formData.from === "Four Seasons Resort Los Cabos at Costa Palmas" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 250 : 135;
    } else if (
      formData.from === "Four Seasons Resort Los Cabos at Costa Palmas" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 265 : 150;
    } else if (
      formData.from === "Four Seasons Resort Los Cabos at Costa Palmas" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 260 : 145;
    } else if (
      formData.from === "Four Seasons Resort Los Cabos at Costa Palmas" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 310 : 195;
    } else if (
      formData.from === "Four Seasons Resort Los Cabos at Costa Palmas" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 330 : 215;
    }

    //------
    if (formData.from === "Los Barriles" && vehicles === "Suburban") {
      basePrice = isReturn ? 270 : 145;
    } else if (formData.from === "Los Barriles" && vehicles === "Escalade") {
      basePrice = isReturn ? 265 : 150;
    } else if (formData.from === "Los Barriles" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 260 : 145;
    } else if (
      formData.from === "Los Barriles" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 310 : 195;
    } else if (
      formData.from === "Los Barriles" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 330 : 215;
    }

    //------
    if (formData.from === "Cerritos" && vehicles === "Suburban") {
      basePrice = isReturn ? 345 : 185;
    } else if (formData.from === "Cerritos" && vehicles === "Escalade") {
      basePrice = isReturn ? 360 : 200;
    } else if (formData.from === "Cerritos" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 355 : 195;
    } else if (formData.from === "Cerritos" && vehicles === "Sprinter mid-size") {
      basePrice = isReturn ? 405 : 245;
    } else if (formData.from === "Cerritos" && vehicles === "Sprinter large") {
      basePrice = isReturn ? 425 : 265;
    }

    //------
    if (
      formData.from === "Kimpton Mas Olas Resort and Spa" &&
      vehicles === "Suburban"
    ) {
      basePrice = isReturn ? 345 : 185;
    } else if (
      formData.from === "Kimpton Mas Olas Resort and Spa" &&
      vehicles === "Escalade"
    ) {
      basePrice = isReturn ? 360 : 200;
    } else if (
      formData.from === "Kimpton Mas Olas Resort and Spa" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 355 : 195;
    } else if (
      formData.from === "Kimpton Mas Olas Resort and Spa" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 405 : 245;
    } else if (
      formData.from === "Kimpton Mas Olas Resort and Spa" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 425 : 265;
    }

    //------
    if (formData.from === "Todos Santos" && vehicles === "Suburban") {
      basePrice = isReturn ? 345 : 185;
    } else if (formData.from === "Todos Santos" && vehicles === "Escalade") {
      basePrice = isReturn ? 360 : 200;
    } else if (formData.from === "Todos Santos" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 355 : 195;
    } else if (
      formData.from === "Todos Santos" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 405 : 245;
    } else if (
      formData.from === "Todos Santos" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 425 : 265;
    }

    //------
    if (formData.from === "The White Lodge" && vehicles === "Suburban") {
      basePrice = isReturn ? 345 : 185;
    } else if (formData.to === "The White Lodge" && vehicles === "Escalade") {
      basePrice = isReturn ? 360 : 200;
    } else if (
      formData.from === "The White Lodge" &&
      vehicles === "Ford Transit"
    ) {
      basePrice = isReturn ? 355 : 195;
    } else if (
      formData.from === "The White Lodge" &&
      vehicles === "Sprinter mid-size"
    ) {
      basePrice = isReturn ? 405 : 245;
    } else if (
      formData.from === "The White Lodge" &&
      vehicles === "Sprinter large"
    ) {
      basePrice = isReturn ? 425 : 265;
    }

    //------
    if (formData.from === "La Paz" && vehicles === "Suburban") {
      basePrice = isReturn ? 450 : 185;
    } else if (formData.from === "La Paz" && vehicles === "Escalade") {
      basePrice = isReturn ? 465 : 200;
    } else if (formData.from === "La Paz" && vehicles === "Ford Transit") {
      basePrice = isReturn ? 460 : 195;
    } else if (formData.from === "La Paz" && vehicles === "Sprinter mid-size") {
      basePrice = isReturn ? 510 : 245;
    } else if (formData.from === "La Paz" && vehicles === "Sprinter large") {
      basePrice = isReturn ? 530 : 265;
    }






    // Actualizar el estado con el precio calculado
    const convertedPrice = convertToCurrency(basePrice, currency);
    setFormData((prevData) => ({
      ...prevData,
      price: convertedPrice, // Guardamos el precio calculado en formData
    }));
  }, [formData.currency, formData.isReturn, formData.from, formData.vehicles]);

  // Llamar a calculatePrice cuando alguna de las dependencias cambie
  useEffect(() => {
    calculatePrice();
  }, [
    formData.currency,
    formData.isReturn,
    formData.from,
    formData.vehicle,
    calculatePrice,
  ]);

  const handleChange = useCallback((e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    try {
      localStorage.setItem("formData", JSON.stringify(formData));
      console.log("Datos guardados en localStorage", formData);

      navigate("/data-personal");
    } catch (error) {
      console.error("Error saving data:", error);
    } 
  };
  // Función para manejar el cambio de moneda
  const handleCurrencyChange = (currency) => {
    setFormData((prevData) => ({ ...prevData, currency }));
  };
  const {
    currency,
    vehicles,
    departureDate,
    departureTime,

    from,
    to,
  } = formData;
  const areasFrom = [
    "(SJD) Los Cabos international Airport",
    "(MMSL) Cabo San Lucas International Airport",
  ];
  const areas = [
    "--- San Jose del Cabo ---",

    "Cabo Azul, a Hilton Vacation Club",

    "Cabo Surf",

    "Casa Natalia",

    "Club La Costa",

    "Drift Hotel",

    "El Encanto Inn",

    "El Zalate Condos",

    "Flamboyan Hotel and Residences",

    "GR Solaris Lighthouse Los Cabos",

    "Hyatt Place",

    "Hyatt Ziva",

    "Krystal Grand Los Cabos",

    "La Jolla",

    "Las Mananitas",

    "Las Olas",

    "Marisol",

    "Mira Vista",

    "Mykonos",

    "Park Royal Los Cabos",

    "Posada Real",

    "Royal Decameron",

    "Royal Solaris",

    "Sampaguita",

    "Six Two Four Hotel",

    "Soleado Beach & Spa Resort",

    "Suites Las Palmas",

    "The Grand Mayan at Vidanta Los Cabos",

    "Tropicana Los Cabos, Tapestry Collection by Hilton",

    "Viceroy Los Cabos",

    "WorldMark Coral Baja",

    "--- Puerto Los Cabos ---",

    "Acre Resort",

    "Flora Farms",

    "Hotel El Ganzo",

    "JW Marriott Los Cabos Beach Resort & Spa",

    "La Marina Inn",

    "Puerto Los Cabos Residential Area",

    "Secrets Puerto Los Cabos",

    "Zadun, a Ritz-Carlton Reserve",

    "--- East Cape Side ---",

    "El Encanto de la Laguna",

    "--- Corridor ---",

    "Chileno Bay Resort & Residences",

    "Club Regina",

    "Dreams",

    "El Dorado Residential Area",

    "Garza Blanca Resort & Spa",

    "Grand Velas Boutique Los Cabos",

    "Grand Velas Los Cabos",

    "Hampton Inn & Suites by Hilton",

    "Hilton Los Cabos",

    "La Pacifica Los Cabos by Hilton Grand Vacations",

    "Las Ventanas al Paraiso",

    "Le Blanc Spa Resort Los Cabos",

    "Mar del Cabo",

    "Maravilla Los Cabos",

    "Marquis Los Cabos Resort & Spa",

    "Montage Los Cabos",
    "One&Only Palmilla",

    "Palmilla Residential Area",

    "Paradisus",

    "Querencia Residential Area",

    "Solaz",

    "The Westin Resort & Spa",

    "Villa La Valencia Beach Resort & Spa",

    "Zoetry Casa Del Mar Los Cabos",

    "--- Cabo San Lucas ----",

    "1 Homes Preview Cabo",

    "Bahia Hotel and Beach House",

    "Breathless Cabo San Lucas Resort & Spa",
    "Bungalows",

    "Cabo Bello Residential Area",

    "Cabo Del Sol Residential Area",

    "Cabo Inn",

    "Cabo Vista",

    "Casa Dorada At Medano Beach",

    "Casa Pescador",

    "Club Cascadas",

    "Comfort Inn & Suites Los Cabos",

    "Corazon Cabo Resort and Spa",

    "El Encanto All Inclusive Resort at Hacienda Encantada",

    "Esperanza, an Auberge Resort & Spa",

    "Estancia Real",

    "Fairfield Inn By Marriott",

    "Four Seasons Cabo Del Sol",

    "Grand Fiesta Americana",

    "Grand Solmar Lands End Resort",

    "Hacienda Beach",

    "Hacienda Del Mar",

    "Hacienda Encantada Resort & Spa",

    "Holiday Inn Express",

    "Hotel Castillo Blarney",

    "Live Aqua Private Residences Los Cabos",

    "Los Cabos Golf Resort",

    "Los Milagros",

    "Los Patios",

    "Marea Los Cabos",

    "Marina Cabo Plaza",

    "Marina Fiesta",

    "Marina Sol",

    "Marina View Villas",

    "Mayan Monkey Hostel Los Cabos",

    "Me Cabo",

    "Medano Hotel and Suites",

    "Melissa's Apartment",

    "Misiones Del Cabo",

    "One Medano Beach",

    "Pedregal Residential Area",

    "Playa Grande Resort & Spa",

    "Plaza Nautica Condominiums Hotel",

    "Portofino Condos in Pedregal",

    "Pueblo Bonito Los Cabos Blanco",

    "Pueblo Bonito Rose",

    "Puerta Cabos Village",

    "Puerta Del Sol",

    "Punta Ballena Residential Area",

    "Riu Palace Baja California",

    "Riu Palace Cabo San Lucas",

    "Riu Santa Fe",

    "San Angel Suites",

    "Sandos Finisterra",

    "Seven Crown",
    "Siesta Suites",

    "Sirena del Mar",

    "Solmar",

    "Sunrock Hotel & Residences",

    "Terrasol",

    "Tesoro Los Cabos",

    "The Cape Thompson Hotel",

    "The Paraiso Residences",

    "The Residences at La Vista",

    "Tezal Residential Area",

    "Villa Del Arco",

    "Villa Del Palmar",

    "Villa La Estancia",

    "Villa Serena",

    "Vista Encantada Spa Resort & Residences",

    "Vista Vela Condos",

    "Waldorf Astoria Los Cabos Pedregal",

    "--- Cabo San Lucas Pacific Side ---",

    "Diamante",

    "Grand Solmar Pacific Dunes Golf and Spa",

    "Montecristo Residential Area",

    "Nobu Hotel Los Cabos",

    "Pueblo Bonito Pacifica",

    "Pueblo Bonito Sunset Beach",

    "Quivira Residential",

    "The Hard Rock Hotel",

    "Four Seasons Resort Los Cabos at Costa Palmas",

    "Los Barriles",

    "Cerritos",

    "Kimpton Mas Olas Resort and Spa",

    "Todos Santos",

    "The White Lodge",

    "La Paz",
  ];
  const normalizedAreas = areas.map((area) => area.trim());







 

  return (
    <div >
    
      <h2>From Hotel to Airport</h2>
            <form onSubmit={handleSubmit}>

            <div className="form-group">
                <label>From, pickup location</label>
              

                <select name="from"  value={from} onChange={handleChange}>
                  {areas.map((area) => (
                    <option key={area} value={area}>
                      {area}
                    </option>
                  ))}
                </select>
              </div>
   {/* To */}
   <div className="form-group">
                <label>Going to</label>
                <select name="to" value={to}  onChange={handleChange}>
                  {areasFrom.map((area) => (
                    <option key={area} value={area}>
                      {area}
                    </option>
                  ))}
                </select>
              </div>
              {/* From */}

          

           

              {/* Departure Date & Time */}
              <div className="d-flex gap-2">
                <div className="form-group">
                  <label>Departure Date</label>
                  <input
                    type="date"
                    name="departureDate"
                    value={departureDate}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label>Departure Time</label>
                  <input
                    type="time"
                    name="departureTime"
                    value={departureTime}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="d-flex gap-2 flex-wrap">
                <div className="form-group">
                  <label>Vehicle</label>
                  <select
                    onChange={handleChange}
                    name="vehicles"
                    value={vehicles}
                  >
                    <option value="Suburban">Suburban (Up to 7 passengers)</option>
                    <option value="Escalade">Escalade (Up to 5 passengers)</option>
                    <option value="Ford Transit">Ford Transit (Up to 11 passengers)</option>
                    <option value="Sprinter mid-size">Sprinter mid-size (Up to 16 passengers)</option>
                    <option value="Sprinter large">Sprinter mid-size (Up to 19 passengers)</option>
                  </select>
                </div>

                {/* Passengers */}
            
              </div>

              {/* Return Toggle */}

           
              <div className="currency-toggle">
                {["USD", "MXN"].map((curr) => (
                  <button
                    key={curr}
                    type="button"
                    className={currency === curr ? "active" : ""}
                    onClick={() => handleCurrencyChange(curr)}
                  >
                    {curr}
                  </button>
                ))}
              </div>
              <div className="form-group">
              {normalizedAreas.includes(from.trim()) &&
                [
                  "Suburban",
                  "Escalade",
                  "Ford Transit",
                  "Sprinter mid-size",
                  "Sprinter large",
                ].includes(vehicles) ? (
                  <h1 style={{ textAlign: "center" }}>
                    Total: ${formData.price} {currency}
                  </h1>
                ) : null}
              </div>

              {/* Submit Button */}
              <div class="col-12">
                <button class="btn btn-primary w-100 py-2">Book Now</button>
              </div>
            </form>
    </div>
      
  );
}

export default FormHotelToAirport;
